'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { ClientLogger } from '@fff-web/logger/client';
import { env } from '../../_config/env.client';

interface DatadogInitializerProps {
  sessionId?: string;
  version?: string;
}

/**
 * Initializes Datadog Logs and RUM services.
 * This component should be rendered once in the root layout.
 * It sets the session ID for Logs and initializes the RUM session.
 */
export const DatadogInitializer = ({ sessionId, version }: DatadogInitializerProps) => {
  useEffect(() => {
    // Initialize Logs session
    if (sessionId) {
      ClientLogger.setSessionId(sessionId);
    }

    // Initialize RUM session
    // This check prevents re-initialization on hot reloads
    if (datadogRum.getInternalContext() === undefined) {
      if (env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID && env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN) {
        datadogRum.init({
          applicationId: env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID,
          clientToken: env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN,
          site: 'datadoghq.com',
          service: 'maui',
          env: env.NEXT_PUBLIC_APP_ENV,
          version: version,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input',
          allowedTracingUrls: [
            /https:\/\/(?:.*\.)?fff-dev\.com/,
            /https:\/\/(?:.*\.)?fabfitfun\.com/,
          ],
        });
      }
    }
  }, [sessionId, version]);

  return null;
};
